import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Pedido } from './models/pedido';
import { PedidoPdf } from './models/pedido-pdf';
import { PedidoStatusHistorico } from './models/pedido-status-historico';
import { PedidoStatusFluxo } from './models/pedido-status-fluxo';
import { PedidoProduto } from './models/pedido-produto';
import { PedidoProdutoPdf } from './models/pedido-produto-pdf';
import { PedidoStatus } from './models/pedido-status';


@Injectable({
    providedIn: 'root'
  })

export class PedidoService{
    
    private environmentUrl: string = '';    

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getPedidos(tipo: string) : Observable<Pedido[]>{
        let url = this.environmentUrl+"/Pedido/Tipo/"+tipo;        
        return this.httpClient.get<Pedido[]>(url);
    }    

    getPedido(idPedido: string) : Observable<Pedido>{        
        let url = this.environmentUrl+"/Pedido/"+idPedido;        
        return this.httpClient.get<Pedido>(url);
    }

    getPedidoGuid(idPedido: string) : Observable<Pedido>{        
        let url = this.environmentUrl+"/Pedido/guid/"+idPedido;        
        return this.httpClient.get<Pedido>(url);
    }


    getPedidoEvento(idPedido: string) : Observable<Pedido>{        
        let url = this.environmentUrl+"/Pedido/Evento/get/"+idPedido;        
        return this.httpClient.get<Pedido>(url);
    }

    getPedidosEvento(idEvento: string) : Observable<Pedido[]>{        
        let url = this.environmentUrl+"/Pedido/Evento/"+idEvento;        
        return this.httpClient.get<Pedido[]>(url);
    }
    
    getPedidoPdf(idPedido: string) : Observable<PedidoPdf>{        
        let url = this.environmentUrl+"/Pedido/v1/Pdf/"+idPedido;        
        return this.httpClient.get<PedidoPdf>(url);
    }

    getPedidoEventoPdf(idPedido: string) : Observable<PedidoPdf>{        
        let url = this.environmentUrl+"/Pedido/v1/Evento/Pdf/"+idPedido;        
        return this.httpClient.get<PedidoPdf>(url);
    }


    getPedidoListaStatus(idPedido: string) : Observable<PedidoStatusHistorico[]>{        
        let url = this.environmentUrl+"/PedidoStatus/PedidoStatusHistorico/"+idPedido;   
        console.log (url);    
        return this.httpClient.get<PedidoStatusHistorico[]>(url);
    }

    getPedidoListaStatusFluxo(idPedidoStatus: string, idUsuario: string) : Observable<PedidoStatusFluxo[]>{        
        let url = this.environmentUrl+"/PedidoStatus/PedidoStatusFluxo/"+idPedidoStatus+"/"+idUsuario;           
        return this.httpClient.get<PedidoStatusFluxo[]>(url);
    }

    getPedidoProdutoLista(idPedido) : Observable<PedidoProduto[]>{        
        let url = this.environmentUrl+"/Pedido/"+idPedido+"/PedidoProduto";           
        return this.httpClient.get<PedidoProduto[]>(url);
    }

    getPedidoProdutoPdfLista(idPedido) : Observable<PedidoProdutoPdf[]>{        
        let url = this.environmentUrl+"/Pedido/v1/"+idPedido+"/PedidoProdutoPdf";           
        return this.httpClient.get<PedidoProdutoPdf[]>(url);
    }

    getPedidoProdutoEventoPdfLista(idPedido) : Observable<PedidoProdutoPdf[]>{        
        let url = this.environmentUrl+"/Pedido/v1/"+idPedido+"/PedidoProdutoEventoPdf";           
        return this.httpClient.get<PedidoProdutoPdf[]>(url);
    }

    AtualizaPedidoStatus(idPedido: string, idPedidoStatus: string, idUsuario: number, obs: string){
        let url = this.environmentUrl+"/Pedido/AtualizaPedidoStatus"   
        
        return this.httpClient
        .put(
          url,
          {IdPedido:idPedido, IdPedidoStatus:idPedidoStatus, IdUsuarioAlteracao:idUsuario ,Obs: obs},
          {observe: 'response'}
        )
        .pipe(tap(res=>{
          console.log(res.body);          
        }))
        ;
    }

  

}

  
  